<div class="iframe-container">
    <iframe
        class="responsive-iframe"
        width="400"
        height="400"
        frameborder="0"
        style="border: 0"
        referrerpolicy="no-referrer-when-downgrade"
        [src]="iframeSrc"
    ></iframe>
</div>
